
export default {

    getGender() {
        return window.restApi.get('v2/master/gender/list?perPage=1000000');
    },    
    getPermission() {
        return window.restApi.get('v2/master/permission/list?perPage=1000000');
    },        
    getRole() {
        return window.restApi.get('v2/user/role/list?perPage=1000000');
    },            
}